import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import Workspace from "../../../model2/space/workspaces/workspace"
import ProjectSession from "../../../model2/project/project-session"
import Modal_getMissingUsers, {ModalMoveTo_MissingUsers} from "../../move-to/actions/get-missing-users"
import {MissingUsersManagerInterface} from "../../components/add-missing-users/missing-users-manager-interface"

// const debug = "Copy_Manager"
const debug = false

export class Copy_Manager implements MissingUsersManagerInterface {

    public type                 : ModalCopy_Type

    public targetWorkspace?     : Workspace         // workspace we add to
    public targetProject?       : ProjectSession    // project we add to
    public missingUsers?        : ModalMoveTo_MissingUsers

    public currentStep          : ModalCopy_CurrentStep = ModalCopy_CurrentStep.LOADING

    public onCopy?              : func              // callback on copy is commited

    public reRender             : callback          // rerender modal callback

    protected result            : any               // stores modal form result while users are validated

    constructor(type: ModalCopy_Type) {
        this.type       = type

        this.reRender   = () => {
            console.warn('Copy_Manager: reRender is not implemented')
        }
    }

    init = async () => {
        /*should be overridden*/
    }

    async validateUsers(result: any) {
        this.result = result

        debug && console.log(debug, 'validateUsers', result, this)
        this.setCurrentStep(ModalCopy_CurrentStep.CHECKING_USERS)

        this.targetProject      = gd.session.projects.get(result.parentProject) || undefined
        this.targetWorkspace    = this.targetProject?.workspace || undefined

        this.missingUsers = await Modal_getMissingUsers(this)
        const clearedUsers = _.omitBy(this.missingUsers, _.isEmpty)

        debug && console.log(debug, 'validateUsers', this.missingUsers, clearedUsers)

        if (_.isEmpty(clearedUsers)) {
            this.commitCopy(this.result)
        } else {
            this.onAddMissingUsers()
        }
    }

    async commitCopy(result?: any) {
        /*should be overridden*/
    }

    get modalTitle():string {
        /*should be overridden*/
        return ''
    }

    get showProjectAccess() {
        return false
    }

    get affectedTasksIds(): ID[] {
        return []
    }

    get affectedProjectIds(): ID[] {
        return[]
    }

    commit() {
        this.commitCopy()
    }

    onAddMissingUsers() {
        this.setCurrentStep(ModalCopy_CurrentStep.ADD_MISSING_USERS)
    }

    setCurrentStep = (step: ModalCopy_CurrentStep) => {
        this.currentStep = step
        this.reRender()
    }
}